export enum ProductRatingsEnum {
  QUALITY = 'quality',
  TECHNOLOGY = 'tencology',
  VFM = 'vfm',
  RESPONSIVENESS = 'responsiveness',
  LENS_ZOOM = 'lensZoom',
  COMPACTNESS = 'compactness',
}
